import { render, staticRenderFns } from "./EventAttendance.vue?vue&type=template&id=f31000a0&"
import script from "./EventAttendance.vue?vue&type=script&lang=js&"
export * from "./EventAttendance.vue?vue&type=script&lang=js&"
import style0 from "./EventAttendance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports